import { reactive, onMounted } from '@vue/composition-api';

export async function fetchling(endpoint: string, resource: string) {
  const response = await fetch(
    `${
      process.env.VUE_APP_API_URL
    }/${endpoint}?token=${window.localStorage.getItem(
      'token',
    )}&resourceType=${resource}`,
  );

  return response.json();
}

export async function postling(endpoint: string, body: unknown) {
  const bodyStringified = JSON.stringify(body);
  const response = await fetch(
    `${
      process.env.VUE_APP_API_URL
    }/${endpoint}?token=${window.localStorage.getItem('token')}`,
    { method: 'POST', body: bodyStringified },
  );
  const jsonResponse = await response.json();

  if (jsonResponse.error) {
    throw new Error(jsonResponse.error);
  }

  return jsonResponse;
}

export async function cancelableFetch(
  root: any,
  eventName: string,
  fetchData: any,
): Promise<any> {
  return new Promise(async (resolve, reject) => {
    root.$on(eventName, () => {
      resolve({
        data: [],
        loading: true,
      });
    });
    const data = await fetchData();

    resolve({
      ...data,
      loading: false,
    });
  });
}

export function useScheduled(initialialResource: string) {
  const scheduled = reactive({
    loading: true,
    data: [],
  });

  async function getScheduled(resource: string) {
    scheduled.loading = true;
    const data = await fetchling('scheduled-at', resource);
    scheduled.data = data.scheduled;
    scheduled.loading = false;
  }

  onMounted(async () => getScheduled(initialialResource));

  return { scheduled, getScheduled };
}

export function useMessages(
  initialResource: string,
  processFailed?: (failedMessages: any[], client: string) => any,
) {
  const messages = reactive({
    loading: true,
    failedIds: [],
    waitingIds: 0,
  });

  async function getMessages(resource: string) {
    messages.loading = true;
    messages.failedIds = [];
    const { data, waitingIds } = await fetchling('messages', resource);
    messages.failedIds = processFailed ? processFailed(data, resource) : data;
    messages.waitingIds = waitingIds;
    messages.loading = false;
  }

  onMounted(async () => getMessages(initialResource));

  return { messages, getMessages };
}

export function useWorkflow(initialResource: string) {
  const workflow = reactive({
    loading: true,
    start: '',
    status: '',
  });

  async function getWorkflow(resource: string) {
    workflow.loading = true;
    const data = await fetchling('workflow', resource);
    workflow.status = data.status;
    workflow.start = data.start;
    workflow.loading = false;
  }

  onMounted(async () => getWorkflow(initialResource));

  return { workflow, getWorkflow };
}
